import { Outlet, useNavigation } from "react-router-dom";
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';

import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import styles from  "./layout.module.less";

function Loading() {
  return (
    <div className={styles.loading}>
      <div className={styles.loadingBackground}>&nbsp;</div>
      <div className={styles.loadingContent}>
        <div className={styles.logo}></div>
      </div>
    </div>
  );
}

function Layout() {
  const navigation = useNavigation();

  return (
    <>
      <Header />
      <div className={styles.main}>
        <Outlet />
      </div>
      <Footer />
      {navigation.state === "loading" && <Loading />}
      <TawkMessengerReact
        propertyId="5684f840bc417680255f8b63"
        widgetId="1a7rtmgbq"/>
    </>
  );
}

export default Layout;
